export default "__VITE_ASSET__d61dc634__"